import { Component, OnInit, inject } from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {first, map, mergeMap, tap} from 'rxjs/operators';
import {ClientService} from '../../../client/client.service';
import {Client} from '../../../client/client';
import {Prestatie} from '../../../prestatie/prestatie';
import {PageRequest} from '../../../core/pagination/page-request';
import {Page} from '../../../core/pagination/page';
import {PrestatieService} from '../../../prestatie/prestatie.service';
import {SortOrder} from '../../../core/sort/sort-order';
import {Thuisverzorger} from '../../../thuisverzorger/thuisverzorger';
import {ThuisverzorgerService} from '../../../thuisverzorger/thuisverzorger.service';

@Component({
    templateUrl: './prestaties.page.html',
    styleUrls: ['./prestaties.page.scss'],
    standalone: false
})
export class PrestatiesPage implements OnInit {
  private clientService = inject(ClientService);
  private prestatieService = inject(PrestatieService);
  private thuisverzorgerService = inject(ThuisverzorgerService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  client$: Observable<Client>;
  initialPageRequest: PageRequest<Prestatie> = PageRequest.firstPageRequest<Prestatie>(SortOrder.DESCENDING, 5);
  prestatiesPage$: Subject<Page<Prestatie>> = new ReplaySubject<Page<Prestatie>>(1);
  thuisverzorgers$: Subject<Array<Thuisverzorger>> = new ReplaySubject<Array<Thuisverzorger>>(1);

  ngOnInit(): void {
    this.client$ = this.route.paramMap.pipe(
      map(paramMap => paramMap.get('id')),
      mergeMap(id => this.clientService.getClientById$(id)),
    );
    this.client$.pipe(
      first(),
      mergeMap(client => this.getPrestaties$(client, this.initialPageRequest)),
    ).subscribe();
    this.prestatiesPage$.pipe(
      map(page => page.getItems().map(prestatie => ({id: prestatie.getThuisverzorgerId(), nummer: prestatie.getThuisverzorgerNummer()}))),
      mergeMap(thuisverzorgerIds => this.thuisverzorgerService.getThuisverzorgersByIds$(thuisverzorgerIds)),
      tap(thuisverzorgers => this.thuisverzorgers$.next(thuisverzorgers)),
    ).subscribe();
  }

  navigateToPrestatie(client: Client, prestatie: Prestatie): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}/prestaties/${prestatie.getId()}`);
  }

  onPageChange(client: Client, pageRequest: PageRequest<Prestatie>): void {
    this.getPrestaties$(client, pageRequest).subscribe();
  }

  navigateToClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  private getPrestaties$(client: Client, pageRequest: PageRequest<Prestatie>): Observable<Page<Prestatie>> {
    return this.prestatieService
      .getPrestatiesPage$(client.getId(), pageRequest)
      .pipe(tap(page => this.prestatiesPage$.next(page)));
  }
}
